import Logo from './Logo.js'
export default Logo;
